<script setup>
import { defineProps, defineEmits } from 'vue'
import { t } from '@/i18n'
const props = defineProps({
    params: Object
})

const emit = defineEmits(['close'])

const handleClose = () => {
    emit('close')
}
</script>

<template>
    <transition v-if="params.theme == 1" name="uitoast_center">
        <div v-show="params.show" class="w-max max-w-[90%] md:max-w-2xl px-5 py-7.5 rounded-md bg-black/80 text-white fixed left-1/2 top-1/2 z-[99999999]" style="transform: translate(-50%, -50%);">
            <img src="@/assets/img/logo-w.png" class="w-auto max-w-full h-5 mx-auto mb-7.5 object-contain block">
            <p class="text-sm sm:text-base font-medium text-center">
                <span>{{params.message}}</span>
            </p>
        </div>
    </transition>
    <transition v-else-if="params.theme == 2" name="uitoast_corner">
        <div v-show="params.show" style="width: 360px;max-width: 90%;" class="p-2 bg-default-bg text-default-text md:rounded-md shadow-md fixed top-0 right-0 md:top-4 md:right-4 z-[99999999] flex">
            <em :class="{
                'text-emerald-500': params.type == 'success',
                'text-red-500': params.type == 'fail',
            }" class="pl-2 py-2 block flex-shrink-0">
                <svg v-if="params.type == 'success'" class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z" fill="currentColor"></path>
                </svg>
                <svg v-else-if="params.type == 'fail'" class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 10.5858L9.17157 7.75736L7.75736 9.17157L10.5858 12L7.75736 14.8284L9.17157 16.2426L12 13.4142L14.8284 16.2426L16.2426 14.8284L13.4142 12L16.2426 9.17157L14.8284 7.75736L12 10.5858Z" fill="currentColor"></path>
                </svg>
            </em>
            <div class="p-2 flex-1 overflow-hidden">
                <h6 :class="{
                    'text-emerald-500': params.type == 'success',
                    'text-red-500': params.type == 'fail',
                }" class="mb-2 text-lg font-medium uppercase">{{ params.type == 'success' ? t('成功') : t('错误') }}</h6>
                <p class="text-sm sm:text-base">
                    <span>{{params.message}}</span>
                </p>
            </div>
            <button @click="handleClose()" class="px-2 h-9 bg-transparent flex items-center flex-shrink-0">
                <svg class="w-5 h-5" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
                </svg>
            </button>
        </div>
    </transition>
    <transition v-else name="uitoast_top">
        <div v-show="params.show" class=" fixed left-1/2 top-10 -translate-x-1/2 z-[99999999] flex justify-center">
            <div :class="{
                'bg-emerald-100 text-emerald-500': params.type == 'success',
                'bg-red-100 text-red-500': params.type == 'fail',
            }" class="min-w-[100px] max-w-full p-4">
                <p class="text-base text-pretty font-medium">
                    <em class="w-5 h-5 mr-1 inline-block align-middle">
                        <svg v-if="params.type == 'success'" class="w-full h-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z" fill="currentColor"></path>
                        </svg>
                        <svg v-else-if="params.type == 'fail'" class="w-full h-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 10.5858L9.17157 7.75736L7.75736 9.17157L10.5858 12L7.75736 14.8284L9.17157 16.2426L12 13.4142L14.8284 16.2426L16.2426 14.8284L13.4142 12L16.2426 9.17157L14.8284 7.75736L12 10.5858Z" fill="currentColor"></path>
                        </svg>
                    </em>
                    <span class="align-middle">{{params.message}}</span>
                </p>
            </div>
        </div>
    </transition>
</template>
<style scoped>
.uitoast_top-enter-active, .uitoast_top-leave-active {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
    transition: all 300ms ease-in;
}
.uitoast_top-enter-from, .uitoast_top-leave-to {
    opacity: 0;
    transform: translateX(-50%) translateY(-100%);
    transition: all 300ms ease-in;
}
.uitoast_center-enter-active, .uitoast_center-leave-active {
    opacity: 1;
    transform: scale(1) translate(-50%, -50%);
    transition: all 300ms ease-in;
}
.uitoast_center-enter-from, .uitoast_center-leave-to {
    opacity: 0;
    transform: scale(0) translate(-50%, -50%);
    transition: all 300ms ease-in;
}
.uitoast_corner-enter-active, .uitoast_corner-leave-active {
    opacity: 1;
    transform: translateX(0);
    transition: all 300ms ease-in;
}
.uitoast_corner-enter-from, .uitoast_corner-leave-to {
    opacity: 0;
    transform: translateX(100%);
    transition: all 300ms ease-in;
}
</style>